import { IconName } from '@optimus-web/icons';
import { Link, Stack } from '@optimus-web/core';
import { useTrialBalanceDownloadExcelMutation, useTrialBalanceDownloadPdfMutation } from '../queries';

export const TrialBalanceRowActions = ({ dateISOstring }: { dateISOstring: string }) => {
    const { mutateDownloadExcel, isExcelDownloadPending } = useTrialBalanceDownloadExcelMutation();
    const { mutateDownloadPdf, isPdfDownloadPending } = useTrialBalanceDownloadPdfMutation();

    return (
        <Stack fill>
            <Link
                standalone
                inherit
                icon={IconName.Download}
                as="button"
                disabled={isExcelDownloadPending}
                onClick={() => mutateDownloadExcel(dateISOstring)}
            >
                Excel
            </Link>
            <Link
                standalone
                inherit
                icon={IconName.Download}
                as="button"
                disabled={isPdfDownloadPending}
                onClick={() => mutateDownloadPdf(dateISOstring)}
            >
                PDF
            </Link>
        </Stack>
    );
};
